import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useReactiveVar } from '@apollo/client';
import { templateNameVar } from '../variables';
import GenericFilterTemplateContainer from './GenericFilterTemplateContainer';
import { ADMIN_GENERIC_FILTER_TEMPLATES_READ } from 'constants/rightsCodes';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const { t } = useTranslation();
  const templateName = useReactiveVar(templateNameVar);

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>{`${t('GenericFilterTemplate.Title')}${
          templateName ? `: ${templateName}` : ''
        }`}</Typography>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <IconButton
          color='transparent'
          tooltip={t('Tooltips.GenericFilterTemplate.BackToList')}
          onClick={() => historyContext.push(`/genericFilterTemplates`)}
        >
          <ArrowBack />
        </IconButton>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_GENERIC_FILTER_TEMPLATES_READ}>
        <GenericFilterTemplateContainer />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
